import React, { useEffect, useState } from "react"
import { Redirect } from "react-router-dom"
import { FormattedMessage, injectIntl } from "react-intl"
import { connect, ConnectedProps } from "react-redux"
import ProjectCustomerEditForm from "../../quote/project/customerselectform.component.jsx"
import CalendarEventEdit from "./CalendarEventEditComponent"
import {
    getCalendarEventForm,
    getCalendarEventFormStepIndex,
} from "../../state/calendar-event/CalendarEventFormSelectors"
import {
    patchCalendarEventForm,
    increaseCalendarEventStep,
    resetCalendarEventForm,
} from "../../state/calendar-event/CalendarEventFormActions"

type OwnProps = {
    providedContactId?: string,
}

const CalendarEventCreate = (props: Props) => {
    const [calendarEventId, setCalendarEventId] = useState("")

    useEffect(() => {
        props.resetCalendarEventForm()
        if (props.providedContactId) {
            props.patchCalendarEventForm({
                contactId: props.providedContactId,
            })
        }
    }, [])

    useEffect(() => {
        if (calendarEventId) {
            props.increaseCalendarEventStep()
        }
    }, [calendarEventId])

    const renderStep = () => {
        switch (props.stepIndex) {
        case 0:
            return <>
                <ProjectCustomerEditForm
                    className="px-3"
                    value={props.contactId}
                    renderContactEnabled={true}
                    isCustomerEditable={true}
                    onChange={(contactId) => {
                        props.patchCalendarEventForm({
                            contactId: contactId,
                        })
                        props.increaseCalendarEventStep()
                    }}
                />
                {
                    props.contactId &&
                        <div className={"w-100 d-flex justify-content-end"}>
                            <button
                                className="btn btn-primary"
                                onClick={() => {
                                    props.increaseCalendarEventStep()
                                }}
                                disabled={!props.contactId}>
                                <FormattedMessage
                                    id="calendar.new_event.continue_btn"
                                    defaultMessage="Continue"
                                />
                            </button>
                        </div>
                }
            </>
        case 1:
        case 2:
            return (
                <CalendarEventEdit
                    providedContactId={props.contactId}
                    onSave={(calendarEventId) => {
                        setCalendarEventId(calendarEventId)
                    }}
                />
            )
        case 3:
            if (calendarEventId) {
                return <Redirect to={`/calendar-events/${calendarEventId}/edit`} />
            }
            return <div />
        }
    }

    return (
        <>
            {renderStep()}
        </>
    )
}

const mapState = (state, props: OwnProps) => {
    const calendarEventForm = getCalendarEventForm(state)

    return {
        ...props,
        contactId: calendarEventForm.contactId,
        stepIndex: getCalendarEventFormStepIndex(state),
    }
}
const mapDispatch = {
    patchCalendarEventForm,
    increaseCalendarEventStep,
    resetCalendarEventForm,
}

const connector = connect(mapState, mapDispatch)
type Props = ConnectedProps<typeof connector>
export default connector(injectIntl(CalendarEventCreate))


// WEBPACK FOOTER //
// ./src/calendar/components/CalendarEventCreateComponent.tsx